import classnames from 'classnames';

export const themes = {
  default: ({ isBrowserGreaterThan }) => ({
    thRoot: 'bg-gray-darker image-responsive-cell relative',
    thThumbnail:
      'focus:opacity-75 hover:opacity-75 focus:scale-105 hover:scale-105 transition-transform-opacity',
    thLabel: classnames(
      'reset-heading md:absolute p-2 md:max-w-9/10 md:mt-5 rtl:left-0 top-0 pointer-events-none text-base lg:text-lg uppercase z-1',
      {
        'bg-gray-dark text-white': !isBrowserGreaterThan.S,
        'bg-white text-gray-darker': isBrowserGreaterThan.S,
      },
    ),
    thBody: classnames(
      'absolute sm:relative lg:absolute overflow-hidden p-2 bottom-0 text-white w-full',
      {
        'bg-overlay-black-60': !isBrowserGreaterThan.XS || isBrowserGreaterThan.M,
        'bg-gray-darker': isBrowserGreaterThan.XS && !isBrowserGreaterThan.M,
      },
    ),
  }),
};
